export default __webpack_public_path__ + "static/media/L2L_ConnectLogo_greenblack.a5b2f6a9.svg";